<template>
    <base-dialog max-width="300px" ref="base">
        <v-card min-height="80vh">
            <v-card-title>Запрос</v-card-title>
            <v-card-subtitle>
                <span v-if="payment.refund">На возврат денежных средств</span>
                <span v-else>На пополнение баланса</span>
                <div v-show="client.full_name">№{{ client.number }} {{ client.full_name }}</div>
            </v-card-subtitle>
            <v-card-text>
                <div class="font-weight-medium">Интрукция:</div>
                <div class="mb-3" style="white-space: pre-wrap">{{ shop.add_balance_instruction }}</div>
                <div v-if="payment.refund" class="pb-3">
                    Ваш текущий баланс <span class="font-weight-medium">{{ current_client.balance }}₽</span>
                </div>
                <v-form ref="form" v-model="valid">
                    <v-text-field dense :rules="rules.value" v-model.number="payment.value" outlined label="Сумма"
                                  v-only-number.float
                                  :hint="payment.refund ? 'Должна быть не больше баланса' : 'Укажите сумму из чека!'">
                        <v-icon size="21" slot="append" color="lightgray">{{ icon_rub }}</v-icon>
                    </v-text-field>
                    <v-container v-show="!payment.refund" class="py-0">
                        <v-row align="center" justify="center">
                            <v-col class="text-center pt-0 px-0">
                                <v-img style="border: 1px solid #f2f2f2; border-radius: 15px"
                                       v-if="payment.image_url!==null" :src="payment.image_url"></v-img>
                                <image-input v-else @success="setCheck" :quality="0.9">
                                    <template v-slot:default="{onInputClick}">
                                        <v-btn @click="onInputClick" style="height: 120px; border-radius: 5px !important;" block class="btn">
                                            <div>
                                                <v-icon size="40" color="rgba(0,0,0,.4)">{{ icon_plus }}</v-icon>
                                                <div class="pt-2" style="color: rgba(0,0,0,.4)">Прикрепить чек</div>
                                            </div>
                                        </v-btn>
                                    </template>
                                </image-input>
                            </v-col>
                        </v-row>
                    </v-container>
                    <div v-show="payment.image_url===null&&!payment.refund" class="caption px-3 mt-n3 pb-3">
                        Необходимо прикрепить чек
                    </div>
                    <v-textarea dense no-resize rows="4" v-model.trim="payment.comment" outlined label="Комментарий"
                                hint="Не обязательно" clearable></v-textarea>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-container fluid class="py-0">
                    <v-row>
                        <v-col cols="12" class="pb-1 pt-2 text-right">
                            <v-btn width="108" :disabled="loading" class="btn btn-h mr-2" @click="$refs.base.hide()">
                                Отмена
                            </v-btn>
                            <v-btn width="108" :loading="loading"
                                   :disabled="!valid||(payment.image_url === null&&!payment.refund)" class="btn"
                                   color="success" @click="sendPayment">Отправить
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-actions>
        </v-card>
    </base-dialog>
</template>

<script>
import BaseDialog from "../utils/BaseDialog";
import EventBus from "../../event-bus";
import {mapActions, mapState} from "vuex";
import {mdiCurrencyRub, mdiImagePlus} from "@mdi/js"
import ImageInput from "../utils/ImageInput";
import Vue from "vue";

export default {
    name: "PaymentDialog",
    components: {ImageInput, BaseDialog},
    data() {
        return {
            icon_plus: mdiImagePlus,
            icon_rub: mdiCurrencyRub,

            payment: {
                image: null,
                image_url: null,
                value: null,
                refund: null,
                comment: null,
                client: null,
            },
            client: {
                id: null,
            },

            loading: false,
            valid: false,

            rules: {
                value: [
                    v => !!v || 'Обязательно для заполнения',
                    v => !isNaN(v) || 'Только числа',
                    v => v > 0 || 'Сумма должна быть больше нуля',
                ]
            }
        }
    },
    computed: {
        ...mapState('clients', [
            'current_client'
        ]),
        ...mapState('shop', [
            'shop'
        ])
    },
    methods: {
        ...mapActions('payments', [
            'addPayment'
        ]),
        setCheck(result) {
            const vm = this;
            vm.payment.image = new File([result], 'check.jpeg', {type: 'image/jpeg', lastModified: Date.now()});
            vm.payment.image_url = URL.createObjectURL(result);
        },
        sendPayment() {
            const vm = this;
            if (!vm.valid || !vm.payment.client) {
                return;
            }
            this.loading = true;
            if (vm.payment.refund) {
                delete this.payment.image;
            }
            this.addPayment(vm.payment)
                .then(() => {
                    this.loading = false;
                    Vue.toasted.show(`УВЕДОМЛЕНИЕ<br>Ваш запрос на ${vm.payment.refund ? 'возврат денежных средств' : 'пополнение баланса'} на сумму ${vm.payment.value}₽ успешно отправлен и находится сейчас в обработке у администрации сайта.`, {
                        type: 'info',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    }).goAway(10000);
                    this.$refs.base.hide();
                    delete this.payment.image;
                })
                .catch(() => {
                    this.loading = false;
                })
        }
    },
    mounted() {
        const vm = this;
        EventBus.$on('payment_dialog', function ({client_id, value, refund, client}) {
            value = 0 // чтоб клиенты не тупили и сами писали сумму оплаты
            if (vm.$refs.form && value === 0) {
                vm.$refs.form.reset();
            }
            if (client) {
                vm.$set(vm, 'client', client);
            } else {
                vm.$set(vm, 'client', {});
            }
            vm.$set(vm, 'payment', {
                image: null,
                image_url: null,
                value: value,
                refund: refund,
                comment: '',
                client: client_id,
            })
            if (refund) {
                vm.rules.value.push(
                    v => (v <= vm.current_client.balance || !vm.payment.refund) || 'Не может быть больше баланса'
                )
            }
            if (vm.$refs.base) {
                vm.$refs.base.show();
            }
        })
    },
}
</script>

<style scoped>

</style>